// frontend/src/features/equipment/EquipmentSetupWizard/steps/LightingStep.tsx
import { CategoryStep } from './CategoryStep';
import type { PendingEquipment } from '../types';

interface LightingStepProps {
  pendingEquipment: PendingEquipment[];
  onEquipmentChange: (equipment: PendingEquipment[]) => void;
  onManageInEquipment?: () => void;
  isCategoryComplete?: boolean;
}

export function LightingStep({
  pendingEquipment,
  onEquipmentChange,
  onManageInEquipment,
  isCategoryComplete,
}: LightingStepProps) {
  return (
    <CategoryStep
      categoryId="lighting"
      title="What lights are you running?"
      pendingEquipment={pendingEquipment}
      onEquipmentChange={onEquipmentChange}
      onManageInEquipment={onManageInEquipment}
      isCategoryComplete={isCategoryComplete}
    />
  );
}
